<template>
    <Layout>
      <template v-if="this.$route.name == 'add-posts'">
        <PageHeader :title="title1" :items="items"></PageHeader>
      </template>
      <template v-else>
        <PageHeader :title="title2" :items="items"></PageHeader>
      </template>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <form-wizard
                @on-complete="submitData"
                color="#556ee6"
                enctype="multipart/form-data"
                ref="series"
                :finishButtonText="
                  this.$route.name == 'add-ai-tools' ? 'Save as Draft' : 'Update Data'
                "
                back-button-text="Go Back!"
                next-button-text="Go Next!"
              >
                <tab-content
                  title="AI Tool Details"
                  icon="mdi mdi-account-details"
                  :before-change="() => validateFormOne()"
                >
                  <b-form-group>
                    <label for="title"
                      >AI Tool Title <span style="color: red">*</span></label
                    >
                    <b-form-input
                      id="title"
                      v-model="form.title"
                      @keyup.prevent="slugify"
                      placeholder="Enter Post Title"
                      :class="{
                        'is-invalid': submitted && $v.form.title.$invalid,
                      }"
                    ></b-form-input>
                    <div
                      v-if="submitted && !$v.form.title.required"
                      class="invalid-feedback"
                    >
                    AI Tool Title is required.
                    </div>
                  </b-form-group>
                  <b-form-group>
                    <label for="slug">AI Tool Slug </label>
                    <b-form-input id="slug" v-model="form.slug" placeholder="Enter URL Link"></b-form-input>
                  </b-form-group>
                </tab-content>

              </form-wizard>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </template>
  
  <script>
  import Layout from "../../../layouts/main";
  import PageHeader from "@/components/page-header";
  import MixinRequest from "../../../../mixins/request";
  import postsMixin from "../../../../mixins/ModuleJs/ai-tools";
  import { required, maxLength } from "vuelidate/lib/validators";
  import { FormWizard, TabContent } from "vue-form-wizard";
  
  export default {
    data() {
      return {
        submitted: false,
        store: false,
        title1: "Add AI Tool",
        title2: "Edit AI Tool",
        items: [
          {
            text: "Back",
            href: "/ai/ai-tools",
          },
          {
            text: "Data",
          },
        ],
      };
    },
    mixins: [MixinRequest, postsMixin],
    components: {
      Layout,
      PageHeader,
      FormWizard,
      TabContent
    },
    validations: {
      form: {
        title: { required, maxLength: maxLength(400) },
        slug: { required }
      },
    },
    methods: {
      validateFormOne() {
        this.submitted = true;
        if (this.$v.form.title.$invalid || this.$v.form.slug.$invalid) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Please Fill The Required Fields",
          });
          return false;
        }
        return true;
      },
      validateFormTwo() {
        this.store = true;
        return true;
      },
      getFormTitle(id) {
        let res = this.forum.filter((f) => f.id == id);
        if (res.length > 0) {
          return res[0].title;
        }
        return null;
      },
    },
  };
  </script>
  